import styles from "./ScheduleLegend.module.css";

function ScheduleLegend() {
  return (
    <ul className={styles.container}>
      <li className={styles.freeform}>Freeform</li>
      <li className={styles.specialty}>Specialty</li>
      <li className={styles.cp}>Community Programming</li>
    </ul>
  );
}

export default ScheduleLegend;
